import {
  Box,
  Button,
  Tooltip,
  TooltipProps,
  styled,
  tooltipClasses,
  useMediaQuery,
} from '@mui/material';
import classNames from 'classnames';
import { FC, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useLocalStorageSimple } from '../../hooks/useLocalStorage'; 

import { Auth as AuthModalue } from '../../Modules/Auth';
import { Basket } from '../../Modules/Basket';
import { Favorite } from '../../Modules/Favorite';
import { RegisterApi } from '../../api/auth';
import { useOutsideClick } from '../../common/OutsideClick/OutsideClick';
import { Icon } from '../../components';
import { Logo } from '../../components';
import AuthDialog from '../../components/AuthDialog/AuthDialog';
import { CatalogMenu } from '../../components/CatalogMenu';
import { CustomSnackbar } from '../../components/Snackbar';
import { ModalErrorOffline } from '../../hoc/withModal';
import { useAppDispatch } from '../../hooks/redux';
import { useActions } from '../../hooks/useActions';
import { useBasket } from '../../hooks/useBasket';
import { useCatalog } from '../../hooks/useCatalog';
import { useFavorite } from '../../hooks/useFavorite';
import { useLayout } from '../../hooks/useLayout';
import { useSearch } from '../../hooks/useSearch';
import { useUser } from '../../hooks/useUser';

import './Header.sass';
import { Processes } from './Processes';
import { Search } from './Search';

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    borderRadius: '8px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 111,
    display: 'flex',
    justifyContent: 'center',
    top: '-58px !important',
    position: 'absolute',
    right: '-78px',
  },
  [`& .${tooltipClasses.popper}`]: {
    width: '217px',
  },
}));
interface IHeaderProps {
  hide?: string;
}

export const Header: FC<IHeaderProps> = ({ hide }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    setAuthVisible,
    setIsOffline,
    setLoggedIn,
    setSuperAdmin,
    setVisibleDrawerDialog,
    setAuthModal,
    setBasketCatalogItems,
    setOrderQuantity,
    setOrderSum,
    setVisibleCatalogMenu,
    fetchMainCatalog,
  } = useActions();
  const { page } = useLayout();
  const {
    visibleAuthDialog,
    visibleDrawerDialog,
    loggedIn,
    isOffline,
    visibleMenuDialog,
    authModal,
  } = useUser();
  const { logout } = useActions();
  const { visibleMobileMenu, visibleCatalogMenu } = useCatalog();
  const { order_quantity } = useBasket();
  const { favoriteQuantity } = useFavorite();
  const { value, visibleHistory } = useSearch();

  // Возвращает булевое значение true, если ширина экрана max 900px
  const mobileScreen = useMediaQuery('(max-width:900px)');
  // Берем реф объект кнопки каталога
  const setRef = useRef<HTMLDivElement | null>(null);
  // Открыть окно авторизации при клике на Войти
  const handleOpen = () => setAuthVisible(!visibleAuthDialog);
  // Закрываем окно авторизации
  const handleClose = () => setAuthVisible(false);
  // Откываем каталог при клике на кнопку Каталог
  const handleOpenCatalogMenu = () =>
    setVisibleCatalogMenu(!visibleCatalogMenu);
  const handleOpenMobileDrawer = () =>
    setVisibleDrawerDialog(!visibleDrawerDialog);
  const handleCloseMobileDrawer = () => setVisibleDrawerDialog(false);
  //Получить токен
  const [sessionToken, setSessionToken] = useLocalStorageSimple('st', '');
  // Паказываем ошибку, если что-то пошло не так при выходе
  const [errorCheckLogin, setErrorCheckLogin] = useState<any>({} as any);
  //Окно подсказки что не ввели Email
  const [openAlertDataError, setOpenAlertDataError] = useState(true);
  //Закрыть окно подсказки что не ввели Email
  const handleCloseAlertDateError = () => setOpenAlertDataError(false);
  // Берем реф объект профиля
  const profileRef = useRef(null);
  // Закрываем профиль
  const handleTooltipClose = () => {
    setAuthModal(false);
  };
  // Открываем профиль
  const handleTooltipOpen = () => {
    setAuthModal(true);
  };
  // Выходим
  const onLogout = async () => {
    if (window.confirm('Вы действительно хотите выйти ?')) {
      await AuthModalue.Logout(
        dispatch,
        sessionToken,
        setSessionToken
      );
    }
  };
  // Если клик был вне блока кнопки каталога, то скрываем его
  useOutsideClick(setRef, handleOpenCatalogMenu, visibleCatalogMenu);
  // Если клик был вне блока профиля, то скрываем его
  useOutsideClick(profileRef, handleTooltipClose, authModal);

  /*  useEffect(() => {
    window.addEventListener('online', () => setIsOffline(false));
    //Если инета нет, то показываем окно юзеру что, подключения нет
    window.addEventListener('offline', () => setIsOffline(true));
  }, [isOffline]);*/

  /* useEffect(() => {
    if (visibleCatalogMenu) {
      if (page === 'home' || page === 'publication') {
      } else {
        fetchMainCatalog();
      }
    }
  }, [visibleCatalogMenu]);

  useEffect(() => {
    if (visibleMobileMenu) {
      if (page === 'home' || page === 'publication') {
      } else {
        fetchMainCatalog();
      }
    }
  }, [visibleMobileMenu]);*/

  return (
    <header
      className={classNames('header', {
        menu: visibleMenuDialog,
      })}
    >
      <section className="header__top_desktop desktop">
        {/*<CustomButton variant="orange">
          <Icon variant="mark" />
          Покупайте на Dazel
        </CustomButton>*/}
        <ul className="desktop">
          <li>
            <Icon variant="notification" />
          </li>
          <li>
            <Link to="/payment-and-delivery">Оплата и доставка</Link>
          </li>
          <li>
            <Link to="/legal-entity">Юридическим лицам</Link>
          </li>
          <li>
            <Link to="/articles">Статьи</Link>
          </li>
          <li>
            <Link to="/about">О проекте</Link>
          </li>
        </ul>
      </section>
      <section className="header__top_mobile mobile">
        <Icon variant="hamburger" />
        <Logo />
        <div></div>
      </section>
      <div className="header__divider desktop"></div>
      <section className="header__middle_desktop desktop" ref={setRef}>
        <Logo className="header__logo_desktop" />
        <div className="header__logo_desktop-ref">
          <Button
            type="submit"
            variant="blue"
            color="primary"
            fullWidth
            onClick={handleOpenCatalogMenu}
            className={
              visibleCatalogMenu
                ? 'header__catalog_desktop active'
                : 'header__catalog_desktop'
            }
          >
            {visibleCatalogMenu ? (
              <Icon variant="close" />
            ) : (
              <Icon variant="catalog" />
            )}
            Каталог
          </Button>

          <CatalogMenu anchorEl={visibleCatalogMenu} />
        </div>

        {!mobileScreen && <Search />}
        <ul className="header__menu_desktop">
          {loggedIn && (
            <div ref={profileRef}>
              <LightTooltip
                onClose={handleTooltipClose}
                open={authModal}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title={
                  <div className="header__menu_desktop_user">
                    <li>
                      <Icon variant="login" />
                      <span>Профиль</span>
                    </li>
                    <div className="header__menu_desktop_user_wrapper">
                      <Link to="/">Личный кабинет</Link>
                      <p onClick={logout}>Выйти</p>
                    </div>
                  </div>
                }
              >
                <li onClick={handleTooltipOpen}>
                  <Icon variant="login" />
                  <span>Профиль</span>
                </li>
              </LightTooltip>
            </div>
          )}
          {!loggedIn && (
            <li
              onClick={handleOpen}
              style={{ maxWidth: '74px', width: '100%' }}
            >
              <Icon variant="login" />
              <span>Войти</span>
            </li>
          )}
          <li className="header__menu_desktop__list disabled">
            <Icon variant="orders" />
            <span>Заказы</span>
          </li>
          <Link to="/favorites">
            <li>
              <Icon variant="heartOutlinedBlue" />

              {favoriteQuantity !== 0 ? (
                <div className="header__middle__basket_quantity">
                  <span>{favoriteQuantity}</span>
                </div>
              ) : (
                <></>
              )}
              <span>Избранное</span>
            </li>
          </Link>
          <Link to="/basket">
            <li>
              <Icon variant="basket" />
              {order_quantity !== 0 ? (
                <div className="header__middle__basket_quantity">
                  <span>{order_quantity}</span>
                </div>
              ) : (
                <></>
              )}

              <span>Корзина</span>
            </li>
          </Link>
        </ul>
      </section>

      <section
        className={classNames('header__middle_mobile mobile', {
          search_mobile: (value.length !== 0 || visibleHistory) && mobileScreen,
        })}
      >
        {mobileScreen && <Search />}
      </section>
      {page === 'basket' ||
      page === 'favorite' ||
      page === 'other' ||
      page === 'cardPage' ||
      page === 'searchPage' ||
      page === 'order' ||
      hide === 'processes' ? (
        <></>
      ) : (
        <Processes className={page === 'home' ? 'home' : ''} />
      )}
      {visibleDrawerDialog && (
        <AuthDialog
          window="drawer"
          open={visibleDrawerDialog}
          handleOpen={handleOpenMobileDrawer}
          handleClose={handleCloseMobileDrawer}
          defaultType="register"
          position="bottom"
        />
      )}
      {visibleAuthDialog && (
        <AuthDialog
          window="modal"
          open={visibleAuthDialog}
          handleOpen={handleOpen}
          handleClose={handleClose}
          defaultType="register"
        />
      )}
      {/*      {page === 'basket' && (
        <section className="header__middle__bottom_desktop">
          <h1>{page === 'basket' ? 'Корзина' : 'Оформление заказа'}</h1>
          <div className="header__middle__bottom_back_desktop">
            <Icon variant="closeBackOrange" />
            <Link to="/">Вернуться к покупкам</Link>
          </div>
        </section>
      )}*/}
      {isOffline && !mobileScreen ? (
        <ModalErrorOffline
          children={
            <Box sx={{ fontSize: '12px' }}>
              Не удалось загрузить данные. Проверьте подключение к сети и
              повторите попытку
            </Box>
          }
        />
      ) : null}
      <CustomSnackbar />
    </header>
  );
};
